import clsx from 'clsx';
import HubertLabel from 'components/HubertUI/HubertLabel';
import HubertSegmentedControl from 'components/HubertUI/HubertSegmentedControl';
import MutedText from 'components/common/MutedText';
import { useQuestionEditorContext, ECreateQuestionMode } from '../context/create-question.context';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionRankingMode, selectQuestionMode } from 'rtk/questionEditorSelector';
import { updateRankingMode } from 'rtk/Question.Editor.Slice';
import { useInTemplateEditAndUneditable } from 'hooks/useInTemplateEditAndUneditable';
import { useTranslation } from 'react-i18next';

const RankingModeSelect = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const rankingMode = useAppSelector((state) => selectQuestionRankingMode(state, questionId));
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  const inTemplateEditAndUneditable = useInTemplateEditAndUneditable(questionId, mode);

  const disabled = mode === ECreateQuestionMode.InTemplateEdit;

  return (
    <div className={clsx(inTemplateEditAndUneditable && 'hidden', 'flex flex-col justify-start gap-4', 'p-1')}>
      <div
        className={clsx(
          inTemplateEditAndUneditable && 'hidden',
          'flex flex-row justify-start gap-4',
          'hubert-vertical-center',
        )}
      >
        <HubertLabel className={clsx('whitespace-nowrap', disabled && 'opacity-50')}>
          {t('rankingMode.label')}
        </HubertLabel>
        <HubertSegmentedControl
          value={rankingMode}
          disabled={disabled}
          onValueChange={(value: string) => {
            if (value === 'dnd' || value === 'click') {
              dispatch(updateRankingMode({ questionId, value }));
            }
          }}
        >
          <HubertSegmentedControl.Item value="dnd">{t('rankingMode.dragAndDrop')}</HubertSegmentedControl.Item>
          <HubertSegmentedControl.Item value="click">{t('rankingMode.click')}</HubertSegmentedControl.Item>
        </HubertSegmentedControl>
      </div>
      <div>
        <MutedText text={t('rankingMode.hint')} />
      </div>
    </div>
  );
};

export default RankingModeSelect;
